/**
 * Loads Swiper when the first carousel requests it.
 * Concurrent callers share one promise. A failed request can be tried again.
 * The data-swiper-src attribute supplies the theme asset URL.
 */
(function () {
  'use strict';

  // scripts.liquid provides a queueing stub until this file runs.
  if (window.__swiperLoaderInstalled) return;
  window.__swiperLoaderInstalled = true;

  var LOAD_TIMEOUT_MS = 10000;

  var loaderScript = document.currentScript || document.querySelector('script[data-swiper-src]');
  var SWIPER_SRC = (loaderScript && loaderScript.getAttribute('data-swiper-src')) || '';

  var sharedPromise = null;

  function injectSwiper() {
    return new Promise(function (resolve, reject) {
      if (window.Swiper) {
        resolve(window.Swiper);
        return;
      }
      if (!SWIPER_SRC) {
        reject(new Error('swiper-loader: no data-swiper-src on the loader script tag'));
        return;
      }

      var script = document.createElement('script');
      var timer = null;
      var settled = false;

      function finish(error) {
        if (settled) return;
        settled = true;
        if (timer) clearTimeout(timer);
        script.removeEventListener('load', onLoad);
        script.removeEventListener('error', onError);

        if (window.Swiper) {
          resolve(window.Swiper);
          return;
        }
        // Drop the failed tag so a retry starts from a clean slate.
        if (script.parentNode) script.parentNode.removeChild(script);
        reject(error || new Error('swiper-loader: script loaded but window.Swiper is missing'));
      }

      function onLoad() {
        finish(null);
      }
      function onError() {
        finish(new Error('swiper-loader: failed to load ' + SWIPER_SRC));
      }

      script.src = SWIPER_SRC;
      script.async = true;
      script.setAttribute('data-swiper-lib', '');
      script.addEventListener('load', onLoad);
      script.addEventListener('error', onError);
      timer = setTimeout(function () {
        finish(new Error('swiper-loader: timed out after ' + LOAD_TIMEOUT_MS + 'ms'));
      }, LOAD_TIMEOUT_MS);

      (document.head || document.documentElement).appendChild(script);
    });
  }

  function loadSwiper() {
    if (window.Swiper) return Promise.resolve(window.Swiper);
    if (sharedPromise) return sharedPromise;

    sharedPromise = injectSwiper()
      .catch(function () {
        return injectSwiper(); // one retry
      })
      .catch(function (error) {
        sharedPromise = null; // let a later trigger try again
        throw error;
      });

    return sharedPromise;
  }

  window.loadSwiper = loadSwiper;

  // Resolve calls held by the queueing stub.
  var queued = window.__swiperQueue;
  window.__swiperQueue = null;
  if (queued && queued.length) {
    loadSwiper().then(
      function (swiper) {
        queued.forEach(function (pending) {
          pending[0](swiper);
        });
      },
      function (error) {
        queued.forEach(function (pending) {
          pending[1](error);
        });
      }
    );
  }

  // A visitor who flicks a carousel the moment it appears should never be left with a
  // dead track. The first touch/pointer press inside any .swiper container primes the
  // load, in parallel with whatever the IntersectionObserver is doing.
  function stopPriming() {
    document.removeEventListener('pointerdown', primeOnInteraction, true);
    document.removeEventListener('touchstart', primeOnInteraction, true);
  }

  function primeOnInteraction(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    if (!target.closest('.swiper')) return;
    stopPriming();
    loadSwiper().catch(function () {});
  }

  document.addEventListener('pointerdown', primeOnInteraction, { passive: true, capture: true });
  document.addEventListener('touchstart', primeOnInteraction, { passive: true, capture: true });
})();
